import { render, staticRenderFns } from "./NewsContent.vue?vue&type=template&id=619c5b7e&scoped=true&"
import script from "./NewsContent.vue?vue&type=script&lang=js&"
export * from "./NewsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c5b7e",
  null
  
)

export default component.exports